import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL } from './base-url';

@Injectable({
  providedIn: 'root'
})
export class ObjectTransitService {

  constructor(public http: HttpClient) { }

  base_URL = BASE_URL;


  addObjectsTransit(body: any) {
    return this.http.post(this.base_URL + 'objectTransit', body)
  }

  getAllObjectsTransit() {
    return this.http.get(this.base_URL + 'objectTransit/all/' + sessionStorage.getItem('cid'))
  }

  hardDeleteObjectTransit(id: any) {
    return this.http.delete(this.base_URL + 'objectTransit/hardDelete/' + id)
  }

  softDeleteObjectTransit(id: any) {
    return this.http.delete(this.base_URL + 'objectTransit/softDelete/' + id)
  }

  updateObjectTransit(body: any) {
    return this.http.put(this.base_URL + 'objectTransit/update', body)
  }

  updateObjectTransitUponApproval(body: any) {
    return this.http.put(this.base_URL + 'objectTransit/updateObjectTransitUponApproval', body)
  }

  getObjectsTransitByObjectTransitId(objectTransitId: any) {
    return this.http.get(this.base_URL + 'objectTransit/' + objectTransitId + '/' + sessionStorage.getItem('cid'))
  }

  insertBulkObjectTransit(body: any) {
    return this.http.post(this.base_URL + 'objectTransit/insertBulkObjectTransit/', body)
  }

  updateBulkObjectTransitUponApproval(body: any) {
    return this.http.put(this.base_URL + 'objectTransit/updateBulkObjectTransitUponApproval', body)
  }

  updateBulkObjectTransitForTransfer(objectTransitId: any, body: any) {
    return this.http.put(this.base_URL + 'objectTransit/updateBulkObjectTransitForTransfer/' + objectTransitId, body)
  }

  getAllByLocationAndNotinTransitAndCid(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllByLocationAndNotinTransitAndCid', body)
  }


  getAllObjectsTransitWithPagination(pageNo: number, recordsPerPage: number) {
    return this.http.get(this.base_URL + 'objectTransit/all/' + sessionStorage.getItem('cid') + '/' + pageNo + '/' + recordsPerPage)
  }

}
